import { put, all, takeEvery } from 'redux-saga/effects';
import actions from './actions';

function* saveZoom({ payload }) {
  yield put(actions.saveZoom(payload));
}

function* saveCoordinates({ payload }) {
  yield put(actions.saveCoordinates(payload));
}

export default function* () {
  yield all([takeEvery('SAVE_COORDINATES', saveCoordinates), takeEvery('SAVE_ZOOM', saveZoom)]);
}
